exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".areachart_wrapper{width:100%;height:100%;position:relative;text-align:center}.areachart_wrapper .highcharts-container{width:100%!important;height:100%!important}.areachart_wrapper .area_legend_items{margin-top:20px}.areachart_wrapper .areachart_container{margin-top:30px;min-height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/usr/src/nuxt-app/assets","/static":"/usr/src/nuxt-app/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eccec6a2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/highchartsAreaChart.vue
// module id = cDh0
// module chunks = 0 2